import { render, staticRenderFns } from "./VehicleAmenitiesSettings.vue?vue&type=template&id=040a0956&scoped=true"
import script from "./VehicleAmenitiesSettings.vue?vue&type=script&lang=js"
export * from "./VehicleAmenitiesSettings.vue?vue&type=script&lang=js"
import style0 from "./VehicleAmenitiesSettings.vue?vue&type=style&index=0&id=040a0956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a0956",
  null
  
)

export default component.exports